import { getElementById } from "components/helpers/ElementHelpers";
import { isNullOrEmpty } from "components/helpers/ObjectHelpers";

export const PreferenceTypes: any = {
    TextSize: "TextSizeStyle",
    DateSize: "DateSizeStyle",
}

export const createTextStyles = (value: number) => {
    const sizes = [
        `xxxl`,
        `xxl`,
        `xxl`,
        `xl`,
        `lg`,
        `md`,
        `sm`,
        `xs`
    ]

    const id = PreferenceTypes.TextSize;

    let css: any = getElementById(id);
    if (css) {
        while (css.firstChild) {
            css.removeChild(css.lastChild);
        }
    }
    else {
        css = document.createElement('style');
        css.id = id;
        css.type = 'text/css';

        document.getElementsByTagName("head")[0].appendChild(css);
    }

    let cssText: string = "";

    if (value > 0) {
        for (const size of sizes) {
            cssText += `.font-size-${size} { font-size: calc(var(--font-size-${size}) + ((var(--font-size-${size}) * ${value}) / 100))  !important; }`;
            
        }
    }
    if (css.styleSheet) {
        css.styleSheet.cssText = cssText; // Support for IE
    }
    else {
        css.appendChild(document.createTextNode(cssText)); // Support for the rest
    }
}

export const createDateStyles = (value: number) => {
    const id = PreferenceTypes.DateSize;

    let css: any = getElementById(id);
    if (css) {
        while (css.firstChild) {
            css.removeChild(css.lastChild);
        }
    }
    else {
        css = document.createElement('style');
        css.id = id;
        css.type = 'text/css';

        document.getElementsByTagName("head")[0].appendChild(css);
    }

    let cssText = "";
    if (value > 0) {
        cssText = `.date-size { font-size: calc(var(--date-size) + ((var(--date-size) * ${value}) / 100))  !important; }`;
    }
    if (css.styleSheet) {
        css.styleSheet.cssText = cssText; // Support for IE
    }
    else {
        css.appendChild(document.createTextNode(cssText)); // Support for the rest
    }
}

export const isSubscriptionUrlActive = (url: string) => {
    const arr = url.split('?');
    if (arr.length < 1) return false;

    const params = arr[1];
    const urlParams = new URLSearchParams(params);
    const id = urlParams.get('id');

    if (isNullOrEmpty(id)) return false;

    return id !== "00000000-0000-0000-0000-000000000000";
}


